import { useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';

import { useVote } from './hooks/useVote';
import { useCarousel } from './hooks/useCarousel';
import { loadImages } from './helpers/preload';

import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { QuizContainer } from './components/QuizContainer/QuizContainer';
import { MessagesList } from './components/MessagesList/MessagesList';

import logoBig from './assets/images/logoBig.webp';
import bgPoster from './assets/images/bgPoster.webp';

import advtBgPoster from './assets/images/advtBgPoster.webp';
import advtBg from './assets/video/advtBg.webm';

function App() {
  const { voteState, currentState, prevState } = useVote();
  const { showedMessages, winnerMessage, speed, mode, keyWinner } =
    useCarousel(currentState);

  //preload
  useEffect(() => {
    const urls = [logoBig, bgPoster];
    loadImages(urls);
  }, []);

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      {/*чтобы не было белого фона при смене интерактивов */}
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={advtBgPoster}
        style={{ zIndex: -150 }}
      >
        <source src={advtBg} type="video/webm" />
      </video>

      <AnimatePresence mode="popLayout">
        {currentState === 'S1' && !prevState && (
          // для первоначальной анимации
          <motion.div
            key="advtFirst"
            initial={{ y: 0, opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ y: '-150%' }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            className="motionBlock"
          >
            <AdvtFullSize />
          </motion.div>
        )}

        {currentState === 'S1' && prevState && (
          <motion.div
            key="advt"
            initial={{ y: 0 }}
            exit={{ y: '-150%' }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            className="motionBlock"
          >
            <AdvtFullSize />
          </motion.div>
        )}

        {['S2', 'S3'].includes(currentState) && (
          <motion.div
            key="quiz"
            className="motionBlock"
            initial={{ y: 0, opacity: 1 }}
            exit={{ y: '170%', opacity: 1 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          >
            <QuizContainer currentState={currentState} voteState={voteState} />
          </motion.div>
        )}

        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <motion.div
            key="messageList"
            className="motionBlock"
            initial={{ y: 0 }}
            exit={{ y: '170%' }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          >
            <MessagesList
              mode={mode}
              key="msgList"
              winId={winnerMessage?.[keyWinner]}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
